import { companyExplorer, dashboardPromo, topPartners, topPracticeGroups, topOffices, newPartners, userIntro, recentTeamingWin, recentAssignments, recentCompanies, memberList, memberListPromo, boxFiles, sharepointFiles, promos, colleagueFinder, dashboard, viewer, quickLinks, calendar, intakeForm } from "@/components/widgets";
const componentList = {
    "recent-assignments": {
        component: recentAssignments,
        displayName: "Assignments"
    },
    "box-files": {
        component: boxFiles,
        displayName: "Box Documents"
    },
    "sharepoint-files": {
        component: sharepointFiles,
        displayName: "SharePoint Documents"
    },
    "calendar": {
        component: calendar,
        displayName: "Calendar"
    },
    "colleague-finder": {
        component: colleagueFinder,
        displayName: "Colleage Finder"
    },
    "company-explorer": {
        component: companyExplorer,
        displayName: "At a glance"
    },
    "recent-companies": {
        component: recentCompanies,
        displayName: "Companies"
    },
    "promos": {
        component: promos,
        displayName: "Content Promotion"
    },
    "dashboard": {
        component: dashboard,
        displayName: "Dashboard"
    },
    "dashboard-promo": {
        component: dashboardPromo,
        displayName: "Dashboard Promo"
    },
    "intake-form": {
        component: intakeForm,
        displayName: "Executive Brief Intake Form"
    },
    "viewer": {
        component: viewer,
        displayName: "Page Viewer"
    },
    "member-list": {
        component: memberList,
        displayName: "People Table View"
    },
    "member-list-promo": {
        component: memberListPromo,
        displayName: "People Tile View"
    },
    "new-partners": {
        component: newPartners,
        displayName: "People Vertical List View"
    },
    "quick-links": {
        component: quickLinks,
        displayName: "Quick Links"
    },
    "recent-teaming-win": {
        component: recentTeamingWin,
        displayName: "Recent Teaming Win"
    },
    "user-intro": {
        component: userIntro,
        displayName: "Single Partner Promo"
    },
    "top-offices": {
        component: topOffices,
        displayName: "Top Offices"
    },
    "top-partners": {
        component: topPartners,
        displayName: "Top Partners"
    },
    "top-practice-groups": {
        component: topPracticeGroups,
        displayName: "Top Practice Groups"
    },
};
const widgets = Object.keys(componentList).map(key => {
    return {
        id: key,
        text: key.substring(0, 1).toUpperCase() + key.replace(/-./g, x => x[1].toUpperCase()).slice(1)
    };
}).reduce((a, c) => { a[c.text] = c.id; return a; }, {});
export { widgets, componentList };
export default {
    setup: (app) => {
        const keys = Object.keys(componentList);
        for (const key of keys) {
            app.component(key, componentList[key].component);
        }
        app.provide("$olympusSections", Object.entries(componentList).reduce((a, c) => (a[c[0]] = c[1].displayName, a), {}));
    }
};
